module.exports = __webpack_public_path__ + "img/Brex.b85b7f72.svg";